const BRANDS = ["AVERY DENNISON", "3M PREFERRED", "XPEL", "CERAMIC PRO", "HEXIS", "KPMF", "INOZETEK", "STEK"];

const Marquee = () => {
  const row = [...BRANDS, ...BRANDS];
  return (
    <div data-testid="brand-marquee" className="relative overflow-hidden border-y border-edge bg-gunmetal py-4 sm:py-5">
      <div className="flex w-max animate-marquee gap-0">
        {[0, 1].map((half) => (
          <div key={half} className="flex shrink-0">
            {row.map((b, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-8 px-8">
                <span className="font-display font-black text-lg sm:text-2xl tracking-tight text-slate-500 whitespace-nowrap">
                  {b}
                </span>
                <span className="h-1.5 w-1.5 rotate-45 bg-velocity shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-gunmetal to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-gunmetal to-transparent" />
    </div>
  );
};

export default Marquee;
